import {
  SPOR_TOTO_SET_POPULAR_SELECTIONS
} from 'Store/constants';

const initialState = {
  selections: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SPOR_TOTO_SET_POPULAR_SELECTIONS:
      return  state.selections.some(event => event.eventId === action.payload.id)
        ? state
        : { ...state, selections: [...state.selections, { eventId: action.payload.id, odds: [...action.payload.odd] }] };
      
    default:
      return state;
  }
};
